import { Injectable } from '@angular/core';
import { HistoryService } from '@serengeti/serengeti-resource';
import { NotificationService, NotificationSubject } from '@serengeti/serengeti-notification';

export class Notification {
	type: string;
	author: string;
  surname: string;
  header: string;
  text: string;
  time: string;
  ago: string;
  expanded: boolean;
  id: string;

	public constructor(id: string, message: string, surname: string, time: string, ago: string, expanded: boolean) {
    this.type = 'text-message';
    this.author = surname;
    this.header = 'header';

    this.surname = surname;
    this.text = message;
    this.time = time;
    this.ago = ago;
    this.expanded = expanded;
    this.id = id;
	}
}

@Injectable({
  providedIn: 'root'
})
export class WizardNotificationHistoryService {

  private _data = [];

  constructor(private historyService: HistoryService) {

  }

  getData() {
    this._data = [];
    this.historyService.search(undefined, 'createdDate', 'desc', undefined, 13,false).subscribe( historys => {
        historys.content.forEach(history => {
            this._data.push(this.convertData(history));
        });
     });
    this._data = this._data.sort(function(a, b) { return (b.time) - (a.time); }); //.slice(0, 10);
    
    return this._data;
  }

  convertData(history: any) {
    const time = history.createdDate;
    const expanded = true;
    const surname = history.ownerId;

    let ago: string;
    let text: string;

    const diff = Math.floor((new Date().getTime() - new Date(history.createdDate).getTime()) / (60 * 1000));
		if (diff < 60) {
			ago = diff + ' minutes ago';
		} else if (diff < 60 * 24) {
			ago = Math.floor(diff / 60) + ' hour before';
		} else {
			ago = Math.floor(diff / 60 / 24) + ' day before';
    }

    switch (NotificationService.category(history)) {
      case NotificationSubject.LogQueue:  {
        break;
      }
      case NotificationSubject.ResourceAction: {
        text =  history.sourceType + ' ' + history.name;
        break;
      }
      case NotificationSubject.ResourceState:  {
        text = history.sourceType + ' ' + history.state + ' ' + history.resultState;
        break;
      }
      case NotificationSubject.SoftwareCatalogState: {
        text = history.name + ' ' + history.state + ' ' + history.resultState;
        break;
      }
      case NotificationSubject.ExecuteState: {
        text = history.name + ' ' + history.state + ' ' + history.resultState;
        break;
      }
      default : {
        console.log('not suported source type');
        break;
      }
    }

    return new Notification(history.id, text, surname, time, ago, expanded);
  }
}
